import { Box } from '@mui/material'
import { FC } from 'react'

export const LoginHeader: FC = () => <Box
    component="header"
    sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
        ml: 2,
        mt: 2,
    }}
>
    <Box
        component="img"
        alt="ConductorOne"
        src="/dapi/static/images/branding/default/logo"
        width={180}
    />
</Box>
